// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__I9E3t","sidebar1":"Sidebar_sidebar1__l6bov","side":"Sidebar_side__TmG+1","con2":"Sidebar_con2__hy9C-"};